import { useRef, useMemo } from 'react';
import { checkDenverSundayNight, calculateNextCheck, getDenverDateAndTime, getCookie, setCookie, secondsToDhms } from '../helper/function';

export const useSundayMidnightCheck = (handleLogout) => {
  const timeoutId = useRef(null);
  const intervalId = useRef(null);

  // Memoize the handleSundayMidnight function to prevent unnecessary recreations
  const handleSundayMidnight = () => {
    const denverNow = getDenverDateAndTime();

    try {
      if (!denverNow) {
        console.error('Could not determine Denver time');
        return;
      }

      const currentSundayKey = `${denverNow.weekday === 'Sunday' ? 'sunday-' : 'monday-'}${denverNow.year}-${denverNow.month}-${denverNow.day}`;
      const hasRun = getCookie(currentSundayKey) === "executed";
  
      if (checkDenverSundayNight() && !hasRun) {
        console.log('Detected Sunday midnight / Monday in Denver - executing cleanup');
        
        setTimeout(() => {
          setCookie(currentSundayKey, "executed", 7);
          handleLogout(); // Call the passed logout function
        }, 1000);
      }
    } catch (e) {
      console.error('Error handling Sunday midnight check:', e);
    }
  }; // Add handleLogout as a dependency

  const scheduleNextCheck = () => {

    const msUntilNextCheck = calculateNextCheck();

    timeoutId.current = setTimeout(() => {
      handleSundayMidnight();
      // After the timeout, check every minute for the hour
      intervalId.current = setInterval(() => {
        handleSundayMidnight();
      }, 60000);
      // Clear the interval after 60 minutes
      setTimeout(() => {
        if (intervalId.current) clearInterval(intervalId.current);
        scheduleNextCheck();
      }, 3600000);
    }, msUntilNextCheck);
  };

  const denverNow = getDenverDateAndTime();

  useMemo(() => {

    handleSundayMidnight();
    scheduleNextCheck();

    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
      if (intervalId.current) clearInterval(intervalId.current);
    };
  }, [denverNow.weekday]);
};